import dayjs from "dayjs";
import {
  cinNumberValidation,
  companyWebsiteValidation,
  gstNumberValidation,
  panNumbervalidation,
} from "../../../components/functions/formValidation";
import {
  ApplicationContextType,
  GstAnalysisStatus,
  UnderwritingSteps,
  uploadStates,
  validationErrorTypes,
} from "../../../interfaces/interfaces";
import { getIn } from "final-form";
import { getFirstShareholdersGridInvalidRange } from "./Shareholder/shareholderHelper";
import _ from "lodash";

export enum companyDocsKeys {
  panCard = "panCard",
  gst = "gstCertificate",
  certificateOfIncorporation = "certificateOfIncorporation",
  memorandumOfAssociation = "memorandumOfAssociation",
  articlesOfAssociation = "articlesOfAssociation",
  udyogAadhar = "udyogAadhar",
  addressProof = "addressProof",
}

export const companyRows = [
  {
    title: "Company's PAN Card",
    subTitle: "",
    key: companyDocsKeys.panCard,
    isMultiFile: false,
  },
  // {
  //     title: "GST Certificate",
  //     subTitle: "Upload certificates for all states.",
  //     key: companyDocsKeys.gst,
  //     isMultiFile: true,
  //     multiFileDetails: {
  //         title: <>Upload GST Certificate</>,
  //         subTitle: <>Upload certificates for all states.</>
  //     }
  // },
  {
    title: "Certificate of Incorporation",
    subTitle: "",
    key: companyDocsKeys.certificateOfIncorporation,
    isMultiFile: false,
  },
  {
    title: "Memorandum of Association",
    subTitle: "",
    key: companyDocsKeys.memorandumOfAssociation,
    isMultiFile: false,
  },
  {
    title: "Article of Association",
    subTitle: "",
    key: companyDocsKeys.articlesOfAssociation,
    isMultiFile: false,
  },
  {
    title: "Udyog Aadhar / Udyam Registration Certificate",
    subTitle: "",
    key: companyDocsKeys.udyogAadhar,
    isMultiFile: false,
  },
];

export const validateCompanyFields = (values) => {
  let errors: any = {};

  const missingData = [];

  // List of fields to validate
  const requiredFields = [
    "companyName",
    "brandName",
    "brandCategory",
    "website",
    // "companyPan",
    // "gstNumber",
    // "cinNumber",
    // "cinCompanyName",
    // "dateOfIncorporation",
    // "currentSameAsRegistered",
  ];
  // Validate required fields
  requiredFields.forEach((field) => {
    if (!values[field]) {
      const errorText = `This field is required`;
      errors[field] = errorText;
      missingData.push(errorText);
    }
  });

  // Specific field validations
  if (values.website) {
    const errorType = companyWebsiteValidation(values.website);
    if (errorType === validationErrorTypes.invalid) {
      const errorText = `Invalid website. Enter a valid URL.`;
      errors.website = errorText;
      missingData.push(errorText);
    }
  }

  //   if (values.companyPan) {
  //     const errorType = panNumbervalidation(values.companyPan);
  //     if (errorType === validationErrorTypes.invalid) {
  //       const errorText = `Enter a valid PAN card number`;
  //       errors.companyPan = errorText;
  //       missingData.push(errorText);
  //     }
  //   }

  // if (values.gstNumber) {
  //     const errorType = gstNumberValidation(values.gstNumber);
  //     if (errorType === validationErrorTypes.invalid) {
  //         const errorText = `Enter a valid GST number`
  //         errors.gstNumber = errorText;
  //         missingData.push(errorText)
  //     }
  // }

  //   if (values.cinNumber) {
  //     const errorType = cinNumberValidation(values.cinNumber);
  //     if (errorType === validationErrorTypes.invalid) {
  //       const errorText = `Enter a valid CIN`;
  //       errors.cinNumber = errorText;
  //       missingData.push(errorText);
  //     }
  //   }

  //   if (values.dateOfIncorporation) {
  //     if (
  //       !(
  //         dayjs(values.dateOfIncorporation, "DD/MM/YYYY").isValid() ||
  //         dayjs(values.dateOfIncorporation).isValid()
  //       )
  //     ) {
  //       errors.dateOfIncorporation = `Enter a valid date`;
  //       missingData.push(`Enter a valid date`);
  //     } else if (dayjs(values.dateOfIncorporation).isAfter(dayjs())) {
  //       errors.dateOfIncorporation = `Enter a date from the past or today`;
  //       missingData.push(`Enter a date from the past or today`);
  //     }
  //   }

  //   if (!values?.shareholderDetails) {
  //     errors["shareholderDetails"] = "Add your company’s shareholding details";
  //     missingData.push("Add your company’s shareholding details");
  //   } else {
  //     const shareholderGridError = getFirstShareholdersGridInvalidRange(
  //       values.shareholderDetails
  //     );
  //     if (shareholderGridError) {
  //       errors["shareholderDetails"] = "Add your company’s shareholding details";
  //       missingData.push("Add your company’s shareholding details");
  //     }
  //   }

  return {
    errors,
    missingData,
  };
};

export const validateCompanyDocs = (values, underwritingFileJobs) => {
  const companyDocs = values?.companyDoc;
  let errors: any = {
    companyDocs: {},
  };
  const allCompanyDocs = getIn(
    underwritingFileJobs,
    `${UnderwritingSteps.company}`
  );
  const missingDocs = [];
  const requirePassword = [];
  const finalCompanyRows = JSON.parse(JSON.stringify(companyRows));
  //   if (values?.currentSameAsRegistered == "no") {
  //     finalCompanyRows.push({
  //       title: "Address Proof",
  //       subTitle: "",
  //       key: companyDocsKeys.addressProof,
  //       isMultiFile: false,
  //     });
  //   }
  //   if (companyDocs) {
  //     finalCompanyRows.forEach((rowData, index) => {
  //       const companyDoc = companyDocs[rowData.key];
  //       if (rowData.isMultiFile) {
  //         if (!companyDoc || !companyDoc?.files?.length) {
  //           // errors[`companyDoc[${rowData.key}].files`] = `Upload document`;
  //           errors = {
  //             ...errors,
  //             companyDoc: {
  //               ...errors.companyDoc,
  //               [`${rowData.key}`]: {
  //                 files: `Upload document`,
  //               },
  //             },
  //           };
  //           missingDocs.push(`Upload document`);
  //         } else {
  //           const fileErrors = [];
  //           companyDoc?.files.forEach((file, index) => {
  //             const docJob =
  //               allCompanyDocs[`companyDoc.${rowData.key}.files[${index}]`];
  //             if (docJob && docJob.status == uploadStates.requiredPassword) {
  //               // errors[`companyDoc[${rowData.key}].files[${index}]`] = `Enter password`;
  //               fileErrors.push(`Enter password`);
  //               requirePassword.push(`Enter password`);
  //             } else {
  //               fileErrors.push("");
  //             }
  //           });
  //           errors = {
  //             ...errors,
  //             companyDoc: {
  //               ...errors.companyDoc,
  //               [`${rowData.key}`]: {
  //                 files: fileErrors,
  //               },
  //             },
  //           };
  //         }
  //       } else {
  //         if (!companyDoc || !companyDoc?.uploadedFile) {
  //           // errors[`companyDoc[${rowData.key}].selectedFile`] = `Upload document`;
  //           errors = {
  //             ...errors,
  //             companyDoc: {
  //               ...errors.companyDoc,
  //               [`${rowData.key}`]: {
  //                 selectedFile: `Upload document`,
  //               },
  //             },
  //           };
  //           missingDocs.push(`Upload document`);
  //         } else {
  //           const docJob = allCompanyDocs[`companyDoc.${rowData.key}`];
  //           if (docJob && docJob.status == uploadStates.requiredPassword) {
  //             // errors[`companyDoc[${rowData.key}].uploadedFile`] = `Enter password`;
  //             errors = {
  //               ...errors,
  //               companyDoc: {
  //                 ...errors.companyDoc,
  //                 [`${rowData.key}`]: {
  //                   uploadedFile: `Enter password`,
  //                 },
  //               },
  //             };
  //             requirePassword.push(`Enter password`);
  //           }
  //         }
  //       }
  //     });
  //   }
  return {
    errors,
    missingDocs,
    requirePassword,
  };
};

export const validateGstDetails = (
  values,
  underwritingFileJobs,
  apiErrors = {},
  gstAnalysisJobs = {},
  formType
) => {
  const gstStatements = values?.gstStatements;
  // console.log('apiErrors', apiErrors)
  const allCompanyDocs = getIn(
    underwritingFileJobs,
    `${UnderwritingSteps.company}`
  );
  const missingDocs = [];
  const requirePassword = [];
  const gstsUnverified = [];
  let isLoading = false;
  if (gstStatements && gstStatements.length) {
    const errors = gstStatements.reduce((prev, statement, index) => {
      let gstStatementErrors: any = {};
      // console.log('statement data', statement?.username)
      const gstInApiErrors = _.get(apiErrors, `gstStatements[${index}].gstin`);
      const gstUsernameErrors = _.get(
        apiErrors,
        `gstStatements[${index}].username`
      );

      const gstInErrorType = gstNumberValidation(statement.gstin);
      // console.log('gstInErrorType', gstInErrorType)
      const gstInValidationError =
        gstInErrorType == validationErrorTypes.invalid
          ? `Enter a valid GST number`
          : gstInErrorType == validationErrorTypes.required
          ? `Enter GST number`
          : "";

      const gstUsernameValidationError = statement?.username
        ? ""
        : `Enter username`;
      if (gstInApiErrors || gstInValidationError) {
        gstStatementErrors["gstin"] =
          gstInApiErrors || gstInValidationError || "";
      }
      if (gstUsernameErrors || gstUsernameValidationError) {
        gstStatementErrors["username"] =
          gstUsernameErrors || gstUsernameValidationError || "";
      }
      // if (!statement?.isVerified) {
      //     gstStatementErrors['isVerified'] = `Verify this account`;
      //     gstsUnverified.push(`Verify this account`);
      // }
      const statementJobId = statement.statementJobId;
      const currentJob: any = _.get(gstAnalysisJobs, `${statementJobId}`);
      // console.log('currentJob', currentJob)
      const checkStatement =
        statement?.isInActive &&
        formType == ApplicationContextType.monthlyReport
          ? false
          : true;
      // console.log('checkStatement', statement)
      // console.log('statement', statement);
      if (
        (!currentJob || currentJob?.status == GstAnalysisStatus.failure) &&
        checkStatement
      ) {
        gstStatementErrors["isVerified"] = `Verify this account`;
        gstsUnverified.push(`Verify this account`);
      }

      if (
        currentJob &&
        currentJob?.status != GstAnalysisStatus.inProgress &&
        !statement?.isVerified &&
        checkStatement
      ) {
        gstStatementErrors["isVerified"] = `Verify this account`;
        gstsUnverified.push(`Verify this account`);
      }

      if (currentJob?.status == GstAnalysisStatus.inProgress) {
        isLoading = true;
      }
      if (!statement?.gstCertificate?.uploadedFile) {
        gstStatementErrors["gstCertificate"] = {
          selectedFile: `Upload document`,
        };
        missingDocs.push(`Upload document`);
      } else {
        const docJob = allCompanyDocs[`gstStatements[${index}].gstCertificate`];
        if (docJob && docJob.status == uploadStates.requiredPassword) {
          gstStatementErrors["gstCertificate"] = {
            uploadedFile: `Enter password`,
          };
          requirePassword.push(`Enter password`);
        }
      }
      prev.push(gstStatementErrors);
      return prev;
    }, []);

    return {
      errors: {
        gstStatements: errors,
      },
      allErrors: {
        missingDocs,
        requirePassword,
        gstsUnverified,
        isLoading: isLoading,
      },
    };
  }
  return {
    errors: {},
    allErrors: {
      missingDocs: [],
      requirePassword: [],
      gstsUnverified: [],
      isLoading: isLoading,
    },
  };
};
